export const MAX_DOC_FILE_MB = 10;
const MAX_DOC_FILE_BYTES = MAX_DOC_FILE_MB * 1024 * 1024;

const DOC_FILE_TYPES = [
  ["image/jpeg", ".jpg", ".jpeg"],
  ["image/png", ".png"],
  ["image/heic", ".heic"],
  ["image/heif", ".heif"],
  ["image/heic-sequence", ".heics"],
  ["image/heif-sequence", ".heifs"],
  ["image/webp", ".webp"],
  ["image/bmp", ".bmp"],
  ["image/avif", ".avif"],
  ["image/gif", ".gif"],
  ["application/pdf", ".pdf"],
];

export const DOC_ACCEPT = DOC_FILE_TYPES.flat().join(",");

export function withDocMimeType(file: File): File {
  if (file.type) return file;
  const name = file.name.toLowerCase();
  const match = DOC_FILE_TYPES.find(([, ...exts]) => exts.some((ext) => name.endsWith(ext)));
  return match ? new File([file], file.name, { type: match[0], lastModified: file.lastModified }) : file;
}

export function isDocTooLarge(file: File): boolean {
  return file.size > MAX_DOC_FILE_BYTES;
}

export function docSizeMb(file: File): string {
  return (Math.ceil((file.size / 1024 / 1024) * 10) / 10).toFixed(1);
}

export function docSizeError(file: File): string | null {
  if (!isDocTooLarge(file)) return null;
  const mb = docSizeMb(file);
  return `That file is ${mb} MB — the limit is ${MAX_DOC_FILE_MB} MB. Please use a smaller photo or a lower-resolution scan.`;
}
